import styled from "styled-components";
import { Button, Select } from "antd";
import DatatableAntd from "components/datatable-antd";

export const Container = styled.div`
    width: 97%;
    height: 85vh;
    overflow: hidden;
    
    position: absolute;
    top: 85px;
    z-index: 10;
    background-color: #fff;
    margin-left: 27px;
    border-radius: 8px;
    padding: 16px;

    display: flex;
    flex-direction: column;
    min-height: 0;

    .ant-form-item {
        display: flex;
        flex-direction: column;
        

        .ant-form-item-label {
            text-align: left;
        }
    }
`;

export const Wrapper = styled.div`
    .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const RowFieldContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;

export const RowField = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SelectAntd = styled(Select)`
  width: 100% !important;

  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }
`;

export const ButtonEdit = styled.button`
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    transition: all 0.2s;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    background: #fff3e0;
    color: #e65100;

    :disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
`;

export const ButtonApprove = styled(ButtonEdit)`
    background: #e8f5e9;
    color: #2e7d32;

    :disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
`;

export const ContentFlex = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
  }

  .ant-table-container {
    border-radius: 8px;
  }

  &.grouped-table > .ant-spin-nested-loading > .ant-spin-container > .ant-table > .ant-table-container
  .ant-table-body .ant-table-tbody 
  > tr.ant-table-row:not(.ant-table-row-level-1):nth-child(even) > td{
    background: transparent !important;
  }

  &.grouped-table .group-row {
    background-color: #faf8f8 !important;
  }

`;

export const ContainerTable = styled.div`
`;

export const FIlterRight = styled.div`
    display: flex;
    gap: 40px;
    flex-wrap: wrap;
`;

export const FilterGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    span {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin-bottom: 4px;
    }
`;

export const FilterOptions = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;
`;

export const CheckBoxItem = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    label {
        display: flex;
        align-items: center;
        gap: 4px;
    }
`;

export const ContainerButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    justify-content: center;
`;

export const ButtonIcon = styled.button`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: none;
    background: #1976d2;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    padding: 0;
    color: #fff;

    svg {
        font-size: 14px;
    }

    :disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const ButtonIconView = styled(ButtonIcon)`
    background: #1976d2;
`;

export const ButtonIconEdit = styled(ButtonIcon)`
    background: #757575;
`;

export const ButtonIconApprove = styled(ButtonIcon)`
    background: #4caf50;
`;

export const ContainerPagination = styled.div`
  margin-top: 10px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalTableContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  flex: 1;
  min-height: 0;
  overflow-y: scroll;
`;

export const ModalContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
  height: 100%;
`;

export const Title = styled.h2`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Textarea = styled.textarea`
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 100%;
  height: 120px;
  padding: 10px;
  outline: none;

  :hover, :focus, :focus-visible {
    border: 1px solid #40a9ff !important;
  }
`;

export const ButtonStyled = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  float: right;
  background-color: #11a557;
  border: none;

  &:hover, &:active, &:focus {
    background-color: #0e8a47;
  }
`